<script>
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import SupplierFormModal from "@/components/modals/supplier-form.vue";

export default {
    components: {
        Multiselect,
        UploadPopover,
        SupplierFormModal,
    },
    data() {
        return {
            title: "Suppliers",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Supplier",
                    active: true,
                },
            ],
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "name",
            sortDesc: false,
            fields: [
                {
                    key: "name",
                    sortable: true,
                    thStyle: { width: "35%" },
                },
                {
                    key: "address",
                    sortable: true,
                },
                {
                    key: "note",
                    sortable: true,
                    thStyle: { width: "20%" },
                },
                {
                    key: "categories",
                    sortable: true,
                    thStyle: { width: "180px" },
                },
                {
                    key: "files",
                    sortable: true,
                    thStyle: { width: "150px" },
                },
                {
                    key: "actions",
                    thStyle: { width: "90px" },
                },
            ],
            form: {
                id: 0,
                name: "",
                address: "",
                tin: "",
                email: "",
                contactNumber: "",
                note: "",
                owner: "",
                businessOrgType: "",
                businessType: "",
                philgeps: "",
                bank: "",
                bankAddress: "",
                accountNumber: "",
                status: "Active",
                vatType: "",
                dtiPermitNumber: "",
                mayorsPermitNumber: "",
                secLicenseNumber: "",
                pcabLicenseNumber: "",
                representative: "",
            },
            indexSelected: -1,
            tableBusy: false,
            companyType: "",
            unit: "",
            itemCategory: "",
            categories: [],
            uploadOptions: {
                type: "Supplier",
                placement: "left",
                folder: "Procurement",
            },
        };
    },
    computed: {
        rows() {
            if(this.filter){
                return this.totalRows;
            }
            return this.tableData.length;
        },
    },
    methods: {
        onFiltered(filteredSuppliers) {
            this.totalRows = filteredSuppliers.length;
            this.currentPage = 1;
        },
        addSupplier() {
            this.$refs.supplierFormModal.onReset();
            this.$refs.supplierFormModal.modalTitle = "Create New Client";
            this.$bvModal.show("supplier-form-modal");
        },
        updateItem(props) {
            this.$refs.supplierFormModal.updateItem(props.item);
            this.indexSelected = this.tableData.indexOf(props.item);
            this.$refs.supplierFormModal.modalTitle = "Update Client";
            this.$bvModal.show("supplier-form-modal");
        },
        hideModal() {
            this.$bvModal.hide("supplier-form-modal");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("supplier/DeleteSupplier", props.item.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.tableData.splice(index, 1);
                                this.showToast("Successfully deleted!", "success");
                            }
                        })
                        .catch((err) => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        viewCategories(props) {
            props.item.viewCat = !props.item.viewCat
            if(props.item.viewFiles){
                props.item.viewFiles = false;
                this.getItemCategory(props);
            }else{
                props.toggleDetails()
                if(!props.detailShowing){
                    this.getItemCategory(props);
                }
            }
        },
        showFiles(props) {
            props.item.viewFiles = !props.item.viewFiles
            if(props.item.viewCat){
                props.item.viewCat = false;
                this.getAttachments(props.item);
            }else{
                props.toggleDetails()
                if(!props.detailShowing){
                    this.getAttachments(props.item);
                }
            }
        },
        getItemCategory(props) {
            this.$store
                .dispatch("supplier/GetSupplierCategory", props.item.id)
                .then((res) => {
                    let availableCategory = [];
                    props.item.selectedCategory = res.data;
                    this.categories.forEach(category => {
                        let found = res.data.findIndex(x => x.itemCategoryId == category.id);
                        if(found < 0){
                            availableCategory.push(category);
                        }
                    })
                    props.item.availableCategory = availableCategory;
                })
                .catch((err) => {
                    this.showToast("Something went wrong! - getting supplier category", "error");
                });
        },
        saveAssignedItems(row) {
            var data = {supplierId: row.item.id, itemCategoryIds: []};
            row.item.categorySelection.forEach((item) => {
                data.itemCategoryIds.push(item.id);
            });
            this.$store
                .dispatch("supplier/CreateSupplierCategory", data)
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    row.item.selectedCategory = res.data;
                    row.item.categorySelection = [];
                    row.toggleDetails();
                    this.showToast("Successfully assigned Item Category!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        removeAssignedItem(row, item) {
            if (!item.id) {
                return;
            }
            this.$store
                .dispatch(
                    "supplier/DeleteSupplierCategory",
                    item.id
                )
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    row.selectedCategory.splice(
                        row.selectedCategory.indexOf(item),
                        1
                    );
                    row.availableCategory.push(item.itemCategory);
                    row.availableCategory.sort((a, b) => {
                        if(a.name < b.name) { return -1; }
                        if(a.name > b.name) { return 1; }
                        return 0;
                    });
                    this.showToast("Successfully deleted!", "success");
                })
                .catch((err) => {
                    this.showToast("Cannot be removing item!", "error");
                });
        },
        getSuppliers() {
            this.totalRows = this.items.length;
            this.tableBusy = true;
            this.$store
                .dispatch("supplier/GetSupplier")
                .then((res) => {
                    this.tableBusy = false;
                    res.data.forEach(item => {
                        item.selectedCategory = []
                        item.availableCategory = []
                        item.viewCat = false;
                        item.viewFiles = false;
                        item.supplierFiles = [];
                        item.attachmentLoading = false;
                        item.fileSearch = "";
                        item.addDocu = false;
                    })
                    this.tableData = res.data;
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong! - getting Client", 'error');
                });
            this.$store
                .dispatch("itemcategory/GetItemCategory")
                .then((res) => {
                    this.categories = res.data.sort((a, b) => {
                        if(a.name < b.name) { return -1; }
                        if(a.name > b.name) { return 1; }
                        return 0;
                    });
                })
                .catch(() => {
                    this.showToast("Something went wrong! - getting Item Category", 'error');
                });
        },
        getAttachments(row) {
            row.supplierFiles = [];
            row.fileSearch = "";
            row.attachmentLoading = true;
            this.$store
                .dispatch("filemanager/GetFiles", {
                    id: row.id,
                    type: this.uploadOptions.type,
                })
                .then((res) => {
                    row.attachmentLoading = false;
                    row.supplierFiles = res.data;
                })
                .catch(() => {
                    row.attachmentLoading = false;
                    this.showToast(
                        "Something went wrong! - getting documents",
                        "error"
                    );
                });
        },
        searchDocu(row) {
            let data = row.supplierFiles;
            if (row.fileSearch.trim() != "" && row.fileSearch) {
                data = data.filter((item) => {
                    return item.description
                        .toUpperCase()
                        .includes(row.fileSearch.toUpperCase());
                });
            }
            return data;
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        removeFile(id, parentId) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("filemanager/DeleteFile", id)
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            let index = this.tableData.findIndex(
                                (item) => item.id == parentId
                            );
                            let yIndex = this.tableData[
                                index
                            ].supplierFiles.findIndex((item) => item.id == id);
                            this.tableData[index].supplierFiles.splice(
                                yIndex,
                                1
                            );
                            this.showToast("Successfully removed!", "success");
                        })
                        .catch(() => {
                            this.showToast("Cannot be deleted!", "error");
                        });
                }
            });
        },
        uploadedFiles(response, id){
            var index = this.tableData.findIndex((x) => x.id == id);
            this.tableData[index].supplierFiles.push(response);
        },
        updateTable($event){
            if($event.type === 'add'){
                this.tableData.push($event.data);
                this.showToast("Successfully created!", "success");
            }else{
                this.tableData.splice(this.indexSelected, 1, $event.data);
                this.showToast("Successfully updated!", "success");
            }
            this.$bvModal.hide("supplier-form-modal");
        },
        printCL(){
            this.$emit('printCL');
        }
    },
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card border">
                    <div class="card-body">
                        <div
                            class="
                                d-flex
                                justify-content-between
                                align-items-center
                            "
                        >
                            <h4 class="card-title m-0">Client Master List</h4>
                            <div class="d-flex">
                                <button
                                    type="button"
                                    @click="printCL"
                                    class="
                                        btn btn-md btn-purple
                                        d-flex
                                        align-items-center
                                        me-2
                                    "
                                >
                                    <i class="bx bx-printer fs-6 me-1"></i>Print Client List
                                </button>
                                <button
                                    type="button"
                                    @click="addSupplier"
                                    class="
                                        btn btn-md btn-info
                                        d-flex
                                        align-items-center
                                    "
                                >
                                    <i class="bx bx-plus fs-6"></i>Create New
                                </button>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_length"
                                    class="dataTables_length"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Show&nbsp;
                                        <b-form-select
                                            class="form-select form-select-sm"
                                            v-model="perPage"
                                            size="sm"
                                            :options="pageOptions"
                                        ></b-form-select
                                        >&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div
                                    id="tickets-table_filter"
                                    class="dataTables_filter text-md-end"
                                >
                                    <label
                                        class="d-inline-flex align-items-center"
                                    >
                                        Search:
                                        <b-form-input
                                            autocomplete="off"
                                            v-model="filter"
                                            type="search"
                                            placeholder="Search..."
                                            class="
                                                form-control form-control-sm
                                                ms-2
                                            "
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                class="datatables"
                                :items="tableData"
                                :fields="fields"
                                responsive="sm"
                                :per-page="perPage"
                                :current-page="currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :filter="filter"
                                :filter-included-fields="filterOn"
                                :busy="tableBusy"
                                @filtered="onFiltered"
                                bordered
                                outlined
                                hover
                                striped
                                show-empty
                            >
                                <template #empty="scope">
                                    <div class="text-center">
                                        {{ scope.emptyText }}
                                    </div>
                                </template>
                                <template #table-busy>
                                    <div
                                        class="
                                            d-flex
                                            justify-content-center
                                            align-items-center
                                        "
                                    >
                                        <div class="preloader-component me-2">
                                            <div class="status">
                                                <div
                                                    class="
                                                        spinner-chase
                                                        w-20px
                                                        h-20px
                                                    "
                                                >
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                    <div
                                                        class="chase-dot"
                                                    ></div>
                                                </div>
                                            </div>
                                        </div>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>
                                <template #cell(name)="row">
                                    <div>{{row.item.name}}</div>
                                    <div class="d-flex">
                                        <small class="me-1 text-muted">{{row.item.email}} <span v-if="row.item.contactNumber && row.item.email">|&nbsp;</span></small>
                                        <small class="me-1 text-muted">{{row.item.contactNumber}} <span v-if="row.item.email && row.item.tin">|&nbsp;</span></small>
                                        <small class="text-muted">{{row.item.tin}}</small>
                                    </div>
                                </template>
                                <template #cell(categories)="row">
                                    <div
                                        class="
                                            d-flex
                                            justify-content-center
                                            mb-2
                                        "
                                    >
                                        <a
                                            href="javascript:void(0);"
                                            @click="viewCategories(row)"
                                            class="
                                                text-white
                                                d-flex
                                                align-items-center
                                            "
                                            ><i class="bx bx-food-menu me-1"></i
                                            >{{
                                                row.item.viewCat
                                                    ? "Hide"
                                                    : "Show"
                                            }}
                                            Categories</a
                                        >
                                    </div>
                                </template>
                                <template #cell(files)="row">
                                    <div
                                        class="
                                            d-flex
                                            justify-content-center
                                            mb-2
                                        "
                                    >
                                        <a
                                            href="javascript:void(0);"
                                            @click="showFiles(row)"
                                            class="
                                                text-white
                                                d-flex
                                                align-items-center
                                            "
                                            ><i class="bx bx-food-menu me-1"></i
                                            >{{
                                                row.item.viewFiles
                                                    ? "Hide"
                                                    : "Show"
                                            }}
                                            Files</a
                                        >
                                    </div>
                                </template>
                                <template #row-details="row">
                                    <div class="p-3 border border-primary" v-if="row.item.viewCat">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <h4 class="font-size-15">
                                                    Assigned Client Category
                                                </h4>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <i
                                                    title="Hide Details"
                                                    class="
                                                        font-size-18
                                                        bx bx-x
                                                        cursor-pointer
                                                    "
                                                    @click="viewCategories(row)"
                                                ></i>
                                            </div>
                                        </div>
                                        <div class="mb-2">
                                            <span
                                                class="multiselect__tag"
                                                v-for="x in row.item
                                                    .selectedCategory"
                                                :key="x.id"
                                                ><span>{{ x.itemCategory.name }}</span>
                                                <i
                                                    class="
                                                        multiselect__tag-icon
                                                    "
                                                    @click="
                                                        removeAssignedItem(
                                                            row.item,
                                                            x
                                                        )
                                                    "
                                                ></i
                                            ></span>
                                        </div>
                                        <div class="row mt-2">
                                            <div class="col-md-10">
                                                <multiselect
                                                    v-model="
                                                        row.item
                                                            .categorySelection
                                                    "
                                                    :options="row.item.availableCategory"
                                                    label="name"
                                                    track-by="id"
                                                    value="id"
                                                    :allow-empty="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="true"
                                                    :preserve-search="true"
                                                    :multiple="true"
                                                    :hide-selected="true"
                                                    placeholder="Select some Client Category"
                                                />
                                            </div>
                                            <div
                                                class="
                                                    col-md-2
                                                    d-flex
                                                    align-items-center
                                                "
                                            >
                                                <button
                                                    class="
                                                        btn
                                                        btn-primary
                                                        btn-block
                                                    "
                                                    type="button"
                                                    @click="
                                                        saveAssignedItems(
                                                            row
                                                        )
                                                    "
                                                >
                                                    <i class="bx bx-save"></i
                                                    >Save Changes
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="p-3 border border-primary" v-if="row.item.viewFiles">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <h4 class="font-size-15">
                                                    Attachments
                                                </h4>
                                            </div>
                                            <div class="col-md-6 text-right">
                                                <div class="">
                                                    <a
                                                        href="javascript:void(0);"
                                                        class="
                                                            text-primary
                                                            border-primary
                                                            border
                                                            p-2
                                                        "
                                                        :id="`supplier-document${row.item.id}`"
                                                        @click="
                                                            row.item.addDocu = true
                                                        "
                                                        ><i
                                                            class="
                                                                bx
                                                                bx-plus
                                                            "
                                                        ></i
                                                        >Upload
                                                        Documents</a
                                                    >
                                                    <upload-popover
                                                        :option="
                                                            uploadOptions
                                                        "
                                                        :sourceId="
                                                            row.item.id
                                                        "
                                                        @uploaded="
                                                            uploadedFiles(
                                                                $event,
                                                                row.item.id
                                                            )
                                                        "
                                                        :showPV="
                                                            row.item.addDocu
                                                        "
                                                        @closePopover="
                                                            row.item.addDocu = false
                                                        "
                                                        :dzId="`dropzone-supplier${row.item.id}`"
                                                        :pvId="`supplier-document${row.item.id}`"
                                                    ></upload-popover>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mt-2">
                                            <b-row>
                                                <b-col
                                                    sm="3"
                                                    v-for="(
                                                        y, index
                                                    ) in searchDocu(
                                                        row.item
                                                    )"
                                                    :key="y.id"
                                                    class="mb-2"
                                                >
                                                    <div
                                                        class="
                                                            position-relative
                                                            cursor-pointer
                                                        "
                                                        :style="`z-index: ${
                                                            row.item
                                                                .supplierFiles
                                                                .length -
                                                            index
                                                        }`"
                                                    >
                                                        <div
                                                            class="
                                                                border
                                                                border-secondary
                                                                p-3
                                                            "
                                                        >
                                                            <div>
                                                                <div
                                                                    class="
                                                                        float-end
                                                                        ms-2
                                                                    "
                                                                >
                                                                    <b-dropdown
                                                                        id="dropdown-dropleft"
                                                                        right
                                                                        variant="link"
                                                                        toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                        menu-class="dropdown-menu-end"
                                                                        no-caret
                                                                    >
                                                                        <template
                                                                            #button-content
                                                                        >
                                                                            <i
                                                                                class="
                                                                                    mdi
                                                                                    mdi-dots-horizontal
                                                                                "
                                                                            ></i>
                                                                        </template>
                                                                        <b-dropdown-item
                                                                            @click="
                                                                                openDocument(
                                                                                    y
                                                                                )
                                                                            "
                                                                            ><i
                                                                                class="
                                                                                    bx
                                                                                    bx-link-external
                                                                                    me-1
                                                                                "
                                                                            ></i
                                                                            >Open</b-dropdown-item
                                                                        >
                                                                        <b-dropdown-item
                                                                            variant="danger"
                                                                            @click="
                                                                                removeFile(
                                                                                    y.id,
                                                                                    row.item.id,
                                                                                    'posted'
                                                                                )
                                                                            "
                                                                            ><i
                                                                                class="
                                                                                    bx
                                                                                    bx-trash
                                                                                    me-1
                                                                                "
                                                                            ></i
                                                                            >Remove</b-dropdown-item
                                                                        >
                                                                    </b-dropdown>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        avatar-xs
                                                                        me-3
                                                                        mb-2
                                                                    "
                                                                    @click="
                                                                        openDocument(
                                                                            y
                                                                        )
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            avatar-title
                                                                            bg-transparent
                                                                            rounded
                                                                        "
                                                                    >
                                                                        <i
                                                                            v-if="
                                                                                y.fileType.includes(
                                                                                    'image'
                                                                                )
                                                                            "
                                                                            class="
                                                                                mdi
                                                                                mdi-image
                                                                                font-size-24
                                                                                text-purple
                                                                            "
                                                                        ></i>
                                                                        <i
                                                                            v-if="
                                                                                y.fileType.includes(
                                                                                    'application'
                                                                                )
                                                                            "
                                                                            class="
                                                                                mdi
                                                                                mdi-file-pdf-outline
                                                                                font-size-24
                                                                                text-danger
                                                                            "
                                                                        ></i>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                    "
                                                                    @click="
                                                                        openDocument(
                                                                            y
                                                                        )
                                                                    "
                                                                >
                                                                    <div
                                                                        class="
                                                                            overflow-hidden
                                                                            me-auto
                                                                        "
                                                                    >
                                                                        <h5
                                                                            class="
                                                                                font-size-14
                                                                                text-truncate
                                                                                mb-1
                                                                            "
                                                                        >
                                                                            {{
                                                                                y.description
                                                                            }}
                                                                        </h5>
                                                                        <p
                                                                            class="
                                                                                text-muted
                                                                                mb-0
                                                                            "
                                                                        >
                                                                            {{
                                                                                formatDateWithTime(
                                                                                    new Date(
                                                                                        y.dateTimeUploaded
                                                                                    )
                                                                                )
                                                                            }}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                            <b-row
                                                v-if="
                                                    searchDocu(
                                                        row.item
                                                    ).length ==
                                                        0 &&
                                                    row.item.fileSearch
                                                "
                                            >
                                                <b-col
                                                    >Search Not
                                                    Found</b-col
                                                >
                                            </b-row>
                                        </div>
                                    </div>
                                </template>
                                <template #cell(actions)="row">
                                    <div class="float-end">
                                        <b-dropdown
                                            id="dropdown-dropleft"
                                            right
                                            variant="link"
                                            toggle-class="text-decoration-none"
                                            menu-class="dropdown-menu-end"
                                            no-caret
                                        >
                                            <template #button-content>
                                                <i
                                                    class="fas fa-ellipsis-v"
                                                ></i>
                                            </template>
                                            <b-dropdown-item
                                                @click="updateItem(row)"
                                                variant="secondary"
                                                ><i
                                                    class="
                                                        mdi mdi-update
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Edit</b-dropdown-item
                                            >
                                            <b-dropdown-item
                                                @click="deleteItem(row)"
                                                variant="danger"
                                                ><i
                                                    class="
                                                        mdi mdi-trash-can
                                                        font-size-18
                                                        me-1
                                                    "
                                                ></i
                                                >Delete</b-dropdown-item
                                            >
                                        </b-dropdown>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div
                                    class="
                                        dataTables_paginate
                                        paging_simple_numbers
                                        float-end
                                    "
                                >
                                    <ul
                                        class="
                                            pagination pagination-rounded
                                            mb-0
                                        "
                                    >
                                        <!-- pagination -->
                                        <b-pagination
                                            v-model="currentPage"
                                            :total-rows="rows"
                                            :per-page="perPage"
                                        ></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <SupplierFormModal ref="supplierFormModal" @update-table="updateTable"></SupplierFormModal>
    </div>
</template>